import { render } from "./CRMFeedbackDatatableActions.vue?vue&type=template&id=1492175f&scoped=true"
import script from "./CRMFeedbackDatatableActions.vue?vue&type=script&lang=js"
export * from "./CRMFeedbackDatatableActions.vue?vue&type=script&lang=js"

import "./CRMFeedbackDatatableActions.vue?vue&type=style&index=0&id=1492175f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1492175f"]])

export default __exports__